@if (launchSource !== 'atlas') {
  <div class="analysis-creation-dialog">
    <p-dialog [(visible)]="showModal" [modal]="true" [dismissableMask]="true" [closable]="true" [position]="'center'"
      [draggable]="false" styleClass="w-50 qubit padding-0" (onHide)="closeDialog()" maskStyleClass="qubit" header="Launch - {{ workspaceSelectorConfig!.title }}">
      <div class="analysis-container d-flex flex-column justify-content-between p-2 gap-1">
        <div class="app-description">
          <p class="label-medium m-0">{{ workspaceSelectorConfig!.description }}</p>
        </div>
        @if (!loadingMessage) {
          <div class="d-flex flex-column gap-2">
            <div class="d-flex flex-column gap-1">
              <label class="align-self-start label-medium"> 1. Select workspace* </label>
              <p-select class="w-100 qubit size-large" [options]="workspaceList" [(ngModel)]="response.workspace"
                [placeholder]="response.workspace.name ? response.workspace.name : 'Select a Workspace'" [panelStyleClass]="'qubit size-large'"
                [disabled]="isSelectedWorkspace" optionLabel="name" dropdownIcon="polly-icon search" filterPlaceholder="Search"
                [filter]="true" (onShow)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_WORKSPACE)" [appendTo]="'body'"
                (onChange)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_WORKSPACE_SELECT)">
              </p-select>
              @if (!response.workspace.value && submitAttempt && response.workspace.id !== -1) {
                <p class="polly-manage-error-message label-medium">
                  Please select a workspace
                </p>
              }
            </div>
            @if (response.workspace.name === NEW_WORKSPACE_DROPDOWN_OPTION) {
              <div class="d-flex flex-column gap-1">
                <label class="align-self-start label-medium"> Name of the Workspace* </label>
                <div class="analysis-input d-flex flex-column gap-1">
                  <input class="w-100 qubit p-inputtext-lg" type="text" [(ngModel)]="response.new_workspace_name" pInputText
                    (focus)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_NAME)" [maxlength]="maxInputLength">
                  @if (response.new_workspace_name && (response.new_workspace_name.length > maxInputLength-1)) {
                    <p class="polly-manage-error-message label-medium">
                      Only {{ maxInputLength }} characters are allowed
                    </p>
                  }
                  @if (!response.new_workspace_name && workspaceSelectorConfig!.input!.name!.required && submitAttempt) {
                    <p class="polly-manage-error-message label-medium">
                      Please enter workspace name
                    </p>
                  }
                </div>
              </div>
            }
            @if (isInternalOrgUser) {
              <div class="d-flex flex-column gap-1">
                <label class="align-self-start label-medium">2. Select a Client Name*</label>
                <p-autocomplete appendTo="body" class="qubit" inputStyleClass="w-100 qubit p-inputtext-lg autocomplete-lg" panelStyleClass="qubit" placeholder="Search Client Organization"
                  [ngModel]='selectedClientName' (ngModelChange)="onClientChange($event)" (onSelect)="onOrgSelection($event.value); showLoader = false" [suggestions]="clientOrgList" (completeMethod)="searchOrganizations($event)"
                  [dropdown]="true" dropdownMode="current" dropdownIcon="polly-icon caret-down" [minQueryLength]="3">
                  <ng-template let-option #item>
                    <div class="d-flex justify-content-between align-items-center flex-1-1-0">
                      <p class="m-0">{{option.label}}</p>
                      <p class="m-0">{{option.value}}</p>
                    </div>
                  </ng-template>
                </p-autocomplete>
                @if (submitAttempt && !response.client.label && !response.client.value) {
                  <p class="polly-manage-error-message label-medium">
                    Please select a client
                  </p>
                }
              </div>
            }
            @if (workspaceSelectorConfig?.input?.name) {
              <div class="d-flex flex-column gap-1">
                <label class="align-self-start label-medium"> {{ isInternalOrgUser ? 3 : 2 }}. Name of the session* </label>
                <input class="w-100 qubit p-inputtext-lg" type="text" [(ngModel)]="response.analysis.name" pInputText
                  (focus)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_NAME)">
                @if (!response.analysis.name && workspaceSelectorConfig?.input?.name?.required && submitAttempt) {
                  <p class="polly-manage-error-message label-medium">
                    Please enter analysis name
                  </p>
                }
              </div>
            }
            @if (workspaceSelectorConfig?.input?.description) {
              <div class="d-flex flex-column gap-1">
                <label class="align-self-start"> {{ isInternalOrgUser ? 4 : 3 }}. Description </label>
                <textarea rows="7" cols="30" [(ngModel)]="response.analysis.description" pTextarea>
                </textarea>
                @if (!response.analysis.description && workspaceSelectorConfig?.input?.description?.required && submitAttempt) {
                  <p class="polly-manage-error-message label-medium">
                    Please enter description
                  </p>
                }
              </div>
            }
          </div>
        }
        @if (loadingMessage) {
          <div class="d-flex flex-column w-100 gap-2">
            @for (_ of [].constructor(3); track $index) {
              <div class="gap-1 d-flex flex-column">
                <p-skeleton class="qubit w-20" height="0.875rem" />
                <p-skeleton class="qubit w-100" height="3rem" />
              </div>
            }
          </div>
        }
      </div>
      <ng-template #footer>
        @if (loadingMessage) {
          <div class="d-flex justify-content-end">
            <p-skeleton height="2rem" width="5rem" class="qubit" />
          </div>
        }
        @if (!loadingMessage) {
          <polly-button (click)="setAnalysisConfig(); sendAnalyticsEvent(GTMEvents.APPLICATIONS_SUBMIT);"
            [label]="'Launch'" [disabled]="showLoader || isInternalOrgUser && !selectedClientName" size="small" [loading]="showLoader">
          </polly-button>
        }
      </ng-template>
    </p-dialog>
  </div>
}

@if (launchSource === 'atlas') {
  @if (!loadingMessage) {
    <div class="analysis-container d-flex flex-column justify-content-between h-100">
      <div class="d-flex flex-column form-container gap-2 flex-grow">
        @if (workspaceSelectorConfig?.input?.name) {
          <div class="d-flex flex-column gap-1">
            <label class="align-self-start label-medium"> 1. Name of the session </label>
            <input class="w-100 qubit p-inputtext-lg" type="text" [(ngModel)]="response.analysis.name" pInputText
              (focus)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_NAME)">
            @if (!response.analysis.name && workspaceSelectorConfig?.input?.name?.required && submitAttempt) {
              <p class="polly-manage-error-message label-medium">
                Please enter analysis name
              </p>
            }
          </div>
        }
        <div class="d-flex flex-column gap-1">
          <label class="label-medium"> 2. Select a Workspace </label>
          <p-select class="w-100 qubit size-large" [options]="workspaceList" [(ngModel)]="response.workspace" [panelStyleClass]="'qubit size-large'"
            [placeholder]="response.workspace.name ? response.workspace.name : 'Select a Workspace'"
            [disabled]="isSelectedWorkspace" optionLabel="name" dropdownIcon="polly-icon search" filterPlaceholder="Search"
            [filter]="true" (onShow)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_WORKSPACE)" appendTo="body"
            (onChange)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_WORKSPACE_SELECT)">
          </p-select>
          @if (!response.workspace.value && submitAttempt && response.workspace.id !== -1) {
            <p class="polly-manage-error-message label-medium">
              Please select a workspace
            </p>
          }
        </div>
        @if (response.workspace.name === NEW_WORKSPACE_DROPDOWN_OPTION) {
          <div class="d-flex flex-column gap-1">
            <label class="align-self-start label-medium"> Name of the Workspace </label>
            <input class="w-100 qubit p-inputtext-lg" type="text" [(ngModel)]="response.new_workspace_name" pInputText
              (focus)="sendAnalyticsEvent(GTMEvents.APPLICATIONS_NAME)" [maxlength]="maxInputLength">
            @if (response.new_workspace_name && (response.new_workspace_name.length > maxInputLength-1)) {
              <p class="polly-manage-error-message label-medium">
                Only {{ maxInputLength }} characters are allowed
              </p>
            }
            @if (!response.new_workspace_name && workspaceSelectorConfig?.input?.name?.required && submitAttempt) {
              <p class="polly-manage-error-message label-medium">
                Please enter workspace name
              </p>
            }
          </div>
        }
        @if (isInternalOrgUser) {
          <div class="d-flex flex-column gap-1">
            <label class="align-self-start label-medium">3. Select a Client Name</label>
            <p-autocomplete appendTo="body" class="qubit" inputStyleClass="w-100 qubit p-inputtext-lg autocomplete-lg" panelStyleClass="qubit" placeholder="Search Client Organization"
              [ngModel]='selectedClientName' (ngModelChange)="onClientChange($event)" (onSelect)="onOrgSelection($event.value); showLoader = false" [suggestions]="clientOrgList" (completeMethod)="searchOrganizations($event)"
              [dropdown]="true" dropdownMode="current" dropdownIcon="polly-icon caret-down" [minQueryLength]="3">
              <ng-template let-option #item>
                <div class="d-flex justify-content-between align-items-center flex-1-1-0">
                  <p class="m-0">{{option.label}}</p>
                  <p class="m-0">{{option.value}}</p>
                </div>
              </ng-template>
            </p-autocomplete>
            @if (submitAttempt && !response.client.label && !response.client.value) {
              <p class="polly-manage-error-message label-medium">
                Please select a client
              </p>
            }
          </div>
        }
        @if (workspaceSelectorConfig?.notebookName) {
          <div class="d-flex flex-column gap-1">
            <label class="align-self-start label-medium"> {{ isInternalOrgUser ? 4 : 3 }}. Name the Notebook </label>
            <input type="text" pInputText [(ngModel)]='response.notebook_name' class="w-100 qubit p-inputtext-lg"
              placeholder="Enter a Notebook name">
            @if (!response.notebook_name && workspaceSelectorConfig?.notebookName?.required && submitAttempt) {
              <p class="polly-manage-error-message label-medium">
                Please enter a notebook name
              </p>
            }
          </div>
        }
      </div>
      <div class="d-flex justify-content-end">
        @if (!loadingMessage) {
          <polly-button class="mt-3" [label]="'Launch'" [disabled]="showLoader  || isInternalOrgUser && !selectedClientName" size="medium" [loading]="showLoader"
            (click)="setAnalysisConfig(); sendAnalyticsEvent(GTMEvents.APPLICATIONS_SUBMIT); sendMixpanelEvent('OmixAtlas_LaunchApp')">
          </polly-button>
        }
      </div>
    </div>
  }
  @if (loadingMessage) {
    <div class="d-flex flex-column w-100 gap-2">
      <div class="gap-1 d-flex flex-column">
        <p-skeleton class="qubit w-20" height="0.875rem" />
        <p-skeleton class="qubit w-100" height="3rem" />
      </div>
      <div class="gap-1 d-flex flex-column">
        <p-skeleton class="qubit w-20" height="0.875rem" />
        <p-skeleton class="qubit w-100" height="3rem" />
      </div>
    </div>
  }
}
